import { render, staticRenderFns } from "./reaksi_transfusi.vue?vue&type=template&id=7229ee5f&scoped=true"
import script from "./reaksi_transfusi.vue?vue&type=script&lang=js"
export * from "./reaksi_transfusi.vue?vue&type=script&lang=js"
import style0 from "./reaksi_transfusi.vue?vue&type=style&index=0&id=7229ee5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7229ee5f",
  null
  
)

export default component.exports
import {QCard,QCardSection,QInput,QBtn,QTooltip,QPagination,QDialog,QSelect,QItem,QItemSection,QItemLabel,QCardActions,QSpinnerDots,QBar,QSpace,QSeparator,QIcon,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QInput,QBtn,QTooltip,QPagination,QDialog,QSelect,QItem,QItemSection,QItemLabel,QCardActions,QSpinnerDots,QBar,QSpace,QSeparator,QIcon})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
